import { getVerdictStyle } from "@/lib/verdictStyles";
import { CheckCircle, XCircle, Warning, Question, ClockCounterClockwise, Detective } from "@phosphor-icons/react";

const ICONS = {
  TRUE: CheckCircle,
  FALSE: XCircle,
  PARTIALLY_TRUE: Warning,
  UNVERIFIABLE: Question,
  OUTDATED: ClockCounterClockwise,
  SATIRE: Detective,
};

export default function VerdictBadge({ verdict, size = "md", shape = "pill", confidence = null }) {
  const s = getVerdictStyle(verdict);
  const Icon = ICONS[verdict] || Question;

  const sizeCls = {
    sm: "text-[10px] px-2 py-0.5",
    md: "text-[11px] px-3 py-1",
    lg: "text-xs px-4 py-1.5",
  }[size];

  const shapeCls = shape === "pill" ? "rounded-full" : "rounded-none";
  const pct = confidence != null ? Math.round(confidence * 100) : null;

  return (
    <span
      data-testid={`verdict-badge-${verdict}`}
      className={`inline-flex items-center gap-1.5 font-mono-plex font-semibold border ${s.border} ${s.bg} ${s.text} ${sizeCls} ${shapeCls}`}
    >
      <Icon weight="fill" className={`${size === "lg" ? "w-4 h-4" : "w-3 h-3"} ${s.iconColor}`} />
      {s.label}
      {pct != null && (
        <span className={`ml-1 pl-1.5 border-l ${s.border} opacity-90`}>{pct}%</span>
      )}
    </span>
  );
}
